import React from 'react';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch, TextField } from '@mui/material';
import { Box } from '@mui/system';
import axiosInstance from '../../../../config/axio.config';
import { useShowMessages } from '../../../../hooks/useMessages/useMessages';

const url = '/systems';

const SystemDialog = (props) => {
  const { ShowMessage } = useShowMessages();
  const editing = !!props.values?.id;

  const handleChangeValues = (e) => {
    props.setValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClose = () => {
    props.setOpen(false);
  };

  const handleClickSend = async () => {
    const description = (props.values?.description || '').trim();
    const type = (props.values?.type || '').trim();

    if (!description) return ShowMessage('error', 'Informe a descrição do sistema');
    if (!type) return ShowMessage('error', 'Informe o tipo do sistema');

    const payload = { description, type, active: props.values?.active === 'N' ? 'N' : 'Y' };

    try {
      if (editing) {
        await axiosInstance.put(`${url}/${props.values.id}`, payload);
        ShowMessage('success', 'Sistema atualizado com sucesso!');
      } else {
        await axiosInstance.post(url, payload);
        ShowMessage('success', 'Sistema cadastrado com sucesso!');
      }
      props.handleChanged();
      handleClose();
    } catch (error) {
      ShowMessage('error', error.response?.data?.message || 'Erro ao salvar o sistema');
    }
  };

  return (
    <Dialog open={props.open} onClose={handleClose}>
      <DialogTitle>{editing ? 'Editar Sistema' : 'Novo Sistema'}</DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%', minWidth: '500px', mt: 1 }}>
          <TextField
            autoFocus
            name="description"
            value={props.values?.description || ''}
            label="Descrição"
            type="text"
            inputProps={{ maxLength: 50 }}
            onChange={handleChangeValues}
            fullWidth
            variant="filled"
          />
        </Box>
        <Box sx={{ width: '100%', minWidth: '500px', mt: 2 }}>
          {/* freeSolo: os tipos já usados viram sugestão, mas nada impede um tipo novo. */}
          <Autocomplete
            freeSolo
            options={props.types || []}
            inputValue={props.values?.type || ''}
            onInputChange={(e, value) => props.setValues((prev) => ({ ...prev, type: value || '' }))}
            renderInput={(params) => (
              <TextField
                {...params}
                name="type"
                label="Tipo"
                variant="filled"
                inputProps={{ ...params.inputProps, maxLength: 30 }}
              />
            )}
          />
        </Box>
        {editing && (
          <Box sx={{ width: '100%', mt: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={props.values?.active !== 'N'}
                  onChange={(e) => props.setValues((prev) => ({ ...prev, active: e.target.checked ? 'Y' : 'N' }))}
                />
              }
              label="Ativo"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ paddingRight: 3 }}>
        <Button onClick={handleClose} variant="outlined" color="error">Cancelar</Button>
        <Button onClick={handleClickSend} variant="outlined" color="success">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SystemDialog;
